export enum MenuItemType {
    ROUTE = 'ROUTE',
    LINK = 'LINK',
    EXTERNAL_LINK = 'EXTERNAL_LINK',
}
